import React from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { EXTENSION_URL } from 'env';
import extensionPinImage from '../../components/home/extra2.png';
import canvasRightClickImage from '../assets/pin-from-canvas-rightclick.png';

const HowToPinModal = ({ open, onClose, messages }) => {
  const { extensionInstalled } = useSelector(state => state.api);

  const openExtensionPage = () => {
    window.open(EXTENSION_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="how-to-pin-dialog"
      PaperProps={{ className: 'how-to-pin-paper' }}
      aria-labelledby="how-to-pin-title"
    >
      <DialogTitle id="how-to-pin-title" className="how-to-pin-title">
        <Typography component="span" variant="h6" className="how-to-pin-title-text">
          {messages.howToPinTitle}
        </Typography>
        <IconButton
          size="small"
          onClick={onClose}
          aria-label={messages.howToPinClose}
          className="how-to-pin-close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent className="how-to-pin-content" dividers>
        <Box className="how-to-pin-step">
          <Box className="how-to-pin-step-heading">
            <Typography className="how-to-pin-step-title">
              {messages.howToPinStep1Title}
            </Typography>
            {!extensionInstalled ? (
              <Button
                variant="outlined"
                onClick={openExtensionPage}
                className="how-to-pin-install-btn"
                startIcon={
                  <Box
                    component="img"
                    src="/img/chrome.svg"
                    alt=""
                    sx={{ width: 30, height: 30 }}
                  />
                }
              >
                {messages.howToPinInstallExtension}
              </Button>
            ) : null}
          </Box>
          <Typography className="how-to-pin-step-desc">
            {messages.howToPinStep1Description}
          </Typography>
          <Box
            component="img"
            src={extensionPinImage}
            alt={messages.howToPinStep1Title}
            className="how-to-pin-image"
          />
        </Box>

        <Box className="how-to-pin-step">
          <Typography className="how-to-pin-step-title">
            {messages.howToPinStep2Title}
          </Typography>
          <Typography className="how-to-pin-step-desc">
            {messages.howToPinStep2Description}
          </Typography>
          <Box
            component="img"
            src={canvasRightClickImage}
            alt={messages.howToPinStep2Title}
            className="how-to-pin-image"
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default HowToPinModal;
